import { useState, useEffect } from "react";
import { ArrowUpRight, Plus, Menu, X } from "lucide-react";
import { BRAND, NAV_LINKS } from "@/data/content";

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className="fixed top-0 left-0 right-0 z-50"
      style={{ padding: scrolled ? "12px 0" : "22px 0", transition: "padding .4s ease" }}
    >
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 flex items-center justify-between">
        {/* Brand */}
        <a href="#top" data-testid="brand-logo" className="flex items-center gap-3 group">
          <span className="grid place-items-center h-9 w-9 rounded-full bg-[var(--ink)] text-[#0a0707] transition-transform duration-500 group-hover:rotate-90">
            <Plus className="h-4 w-4" strokeWidth={2.4} />
          </span>
          <span className="leading-none">
            <span className="block text-[15px] font-medium tracking-tight text-[var(--ink)]">
              {BRAND.creator}
            </span>
            <span className="label block mt-1 !text-[0.6rem]">{BRAND.role}</span>
          </span>
        </a>

        {/* Center pill */}
        <nav className="hidden md:flex nav-pill rounded-full px-2 py-2 items-center gap-1">
          {NAV_LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="nav-link text-sm px-4 py-1.5 rounded-full"
            >
              {l.label}
            </a>
          ))}
        </nav>

        {/* CTA + mobile toggle */}
        <div className="flex items-center gap-3">
          <a
            href="#contact"
            data-testid="nav-cta"
            className="btn-light hidden sm:flex items-center gap-2 rounded-full pl-5 pr-2 py-2 text-sm font-medium"
          >
            Let's connect
            <span className="grid place-items-center h-7 w-7 rounded-full bg-[#0a0707] text-[var(--ink)]">
              <ArrowUpRight className="h-3.5 w-3.5" />
            </span>
          </a>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((o) => !o)}
            className="md:hidden grid place-items-center h-10 w-10 rounded-full nav-pill"
          >
            {open ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div data-testid="mobile-menu" className="md:hidden mx-5 mt-3 nav-pill rounded-2xl p-3">
          {NAV_LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block px-4 py-3 text-[var(--ink)] border-b border-[var(--line)] last:border-0"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            className="btn-light mt-3 flex items-center justify-center gap-2 rounded-full py-3 text-sm font-medium"
          >
            Let's connect <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      )}
    </header>
  );
}
